import React, { useEffect, useState } from 'react'

const ResultPercentage = ({
  answer,
  pollResults,
  totalPollSubmissions,
  activeColor,
  inactiveColor,
}) => {
  const [resultPercentage, setResultPercentage] = useState(0)

  const result = pollResults?.find(item => item.id === answer.id)
  const pollCount = result?.pollAnswerCount || 0

  useEffect(() => {
    if (!result) return

    setTimeout(
      () => setResultPercentage((pollCount / totalPollSubmissions) * 100),
      200,
    )
  }, [pollCount, result, totalPollSubmissions])

  if (!pollResults) return null

  return (
    <div className="poll-answer-result-progress-container">
      <div
        className="poll-answer-result-progress-value"
        style={{
          width: `${resultPercentage}%`,
          backgroundColor: result.userPickedThis ? activeColor : inactiveColor,
        }}
      />

      <p
        className="poll-answer-result-progress-legend"
        style={answer.puckTextStyle}
      >
        {Math.round(resultPercentage)}%
      </p>
    </div>
  )
}

export default ResultPercentage
